import { ProfileCard } from './ProfileCard';

export function ProfileCardWrapper() {
	return (
		<div className="mb-16 px-4 md:px-0">
			<ProfileCard />
		</div>
	);
}
